import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function GlobeIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 18.334a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM1.667 10h16.666" />
        <path d="M10 1.667A12.75 12.75 0 0 1 13.333 10 12.75 12.75 0 0 1 10 18.334 12.75 12.75 0 0 1 6.667 10 12.75 12.75 0 0 1 10 1.667v0Z" />
      </g>
    </Icon>
  );
}
